var styleDataHash = 'dbc44cb6';  
export const injectCss = (() => {
  var css = `.kD1l2{position:relative;width:100%}._4ANA9{max-width:fit-content;min-height:28px;padding:4px}.Fd3S2{border:none;cursor:pointer;display:flex;height:19px;overflow:hidden;padding:0;position:absolute;width:19px;z-index:3}.eO4gd{background-color:#fff;border-radius:4px}.eO4gd:before{background-color:var(--ricos-custom-editor-add-plugin-button-plus-icon-color,var(--ricos-action-color,#116dff));bottom:0;content:"";left:0;opacity:.1;position:absolute;right:0;top:0}.eO4gd svg{color:var(--ricos-custom-editor-add-plugin-button-plus-icon-color,var(--ricos-action-color,#116dff));fill:var(--ricos-custom-editor-add-plugin-button-plus-icon-color,var(--ricos-action-color,#116dff))}.eO4gd:hover{background-color:var(--ricos-custom-editor-add-plugin-button-plus-icon-color,var(--ricos-action-color,#116dff))}.eO4gd:hover svg{color:#fff;fill:#fff}.aObGW{right:var(--ricos-custom-editor-add-plugin-button-position-inline-start,-26px)}.ECP0e,.aObGW{justify-content:start}.ECP0e{left:var(--ricos-custom-editor-add-plugin-button-position-inline-start,-26px)}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "floatingAddPluginMenu_wrapper": "kD1l2",
  "addPluginMenu_horizontal_wrapper": "_4ANA9",
  "floatingAddPluginMenu_plus_button_position": "Fd3S2",
  "floatingAddPluginMenu_plus_button": "eO4gd",
  "rtl": "aObGW",
  "ltr": "ECP0e"
};